import { Controller } from "@hotwired/stimulus"
import { createPhotoSwipeLightbox } from '../lib/photoswipe-lightbox.js'

// Connects to data-controller="photoswipe"
export default class extends Controller {
  connect() {
    // Initialize the lightbox immediately so clicks are captured right away.
    // Dimensions are resolved lazily via the itemData filter (see the shared
    // factory) instead of blocking initialization on an async image-load pass.
    this.lightbox = createPhotoSwipeLightbox(this.element)
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  }
}
